import axios from "axios"
import * as env from "../constants/env"


/* List Studio */
export const list = (page) => {
    const uri = `${env.startpoint}studio/list?page=${page}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Create Studio */
export const create = (data) => {
    const uri = `${env.startpoint}studio/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Edit Studio */
export const edit = (data) => {
    const uri = `${env.startpoint}studio/edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Remove Studio */
export const remove = (data) => {
    const uri = `${env.startpoint}studio/remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}